module.exports = __webpack_public_path__ + "static/media/mobile-alt.ba15e107.svg";